import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { EnumerationItem } from "projects/shared/models/enumeration-item.model";

@Injectable()
export class ChannelService {

  constructor() { }

  getChannelsFromCommaDelimitedString = (channels: string, returnIdAsValue: boolean = false): EnumerationItem[] => {
    if (!channels) {
      return [];
    }
    const channelEnumItems: EnumerationItem[] = [];
    const channelNames: string[] = channels.split(',').map(c => c.trim());
    if (channelNames.includes('Retail')) {
      channelEnumItems.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
    }
    if (channelNames.includes('Wholesale')) {
      channelEnumItems.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
    }
    if (channelNames.includes('Broker')) {
      channelEnumItems.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
    }
    if (channelNames.includes('Correspondent')) {
      channelEnumItems.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
    }
    return channelEnumItems;
  }

  getChannels = (enumFlagValue: number, returnIdAsValue: boolean = false): Array<EnumerationItem> => {
    const channels: Array<EnumerationItem> = [];
    switch (enumFlagValue) {
      case 0:
        break;
      case 1:
        channels.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
        break;
      case 2:
        channels.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
        break;
      case 3:
        channels.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
        channels.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
        break;
      case 4:
        channels.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
        break;
      case 5:
        channels.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
        channels.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
        break;
      case 6:
        channels.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
        channels.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
        break;
      case 7:
        channels.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
        channels.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
        channels.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
        break;
      case 8:
        channels.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
        break;
      case 9:
        channels.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
        channels.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
        break;
      case 10:
        channels.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
        channels.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
        break;
      case 11:
        channels.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
        channels.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
        channels.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
        break;
      case 12:
        channels.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
        channels.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
        break;
      case 13:
        channels.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
        channels.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
        channels.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
        break;
      case 14:
        channels.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
        channels.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
        channels.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
        break;
      case 15:
        channels.push({ name: 'Retail', value: returnIdAsValue ? 1 : 'Retail' });
        channels.push({ name: 'Wholesale', value: returnIdAsValue ? 2 : 'Wholesale' });
        channels.push({ name: 'Broker', value: returnIdAsValue ? 4 : 'Broker' });
        channels.push({ name: 'Correspondent', value: returnIdAsValue ? 8 : 'Correspondent' });
        break;
    }
    return channels;
  };

  getChannelsNumber = (channels: Array<string>): number => {
    if (!channels) return 0;

    let result = 0;
    const orderedChannels = _.sortBy(channels);
    if (_.isEqual(orderedChannels, ["Retail"])) {
      result = 1;
    } else if (_.isEqual(orderedChannels, ["Wholesale"])) {
      result = 2;
    } else if (_.isEqual(orderedChannels, ["Retail", "Wholesale"])) {
      result = 3;
    } else if (_.isEqual(orderedChannels, ["Broker"])) {
      result = 4;
    } else if (_.isEqual(orderedChannels, ["Broker", "Retail"])) {
      result = 5;
    } else if (_.isEqual(orderedChannels, ["Broker", "Wholesale"])) {
      result = 6;
    } else if (_.isEqual(orderedChannels, ["Broker", "Retail", "Wholesale"])) {
      result = 7;
    } else if (_.isEqual(orderedChannels, ["Correspondent"])) {
      result = 8;
    } else if (_.isEqual(orderedChannels, ["Correspondent", "Retail"])) {
      result = 9;
    } else if (_.isEqual(orderedChannels, ["Correspondent", "Wholesale"])) {
      result = 10;
    } else if (_.isEqual(orderedChannels, ["Correspondent", "Retail", "Wholesale"])) {
      result = 11;
    } else if (_.isEqual(orderedChannels, ["Broker", "Correspondent"])) {
      result = 12;
    } else if (_.isEqual(orderedChannels, ["Broker", "Correspondent", "Retail"])) {
      result = 13;
    } else if (_.isEqual(orderedChannels, ["Broker", "Correspondent", "Wholesale"])) {
      result = 14;
    } else if (_.isEqual(orderedChannels, ["Broker", "Correspondent", "Retail", "Wholesale"])) {
      result = 15;
    }
    return result
  }

  getChannelsListForDropdown = (channels: string): Array<EnumerationItem> => {
    return this.getChannelsFromCommaDelimitedString(channels)
      .map(channel => ({
        value: channel.value,
        name: channel.name,
      }));
  }
}
